import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-clock",
  "use": "icon-clock-usage",
  "viewBox": "0 0 25 25",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 25 25\" id=\"icon-clock\"><path d=\"M12.488 23.156c-5.883 0-10.669-4.786-10.669-10.669C1.82 6.605 6.605 1.82 12.488 1.82c5.882 0 10.668 4.786 10.668 10.668 0 5.883-4.786 10.67-10.668 10.67zm0-23.122C5.62.034.034 5.621.034 12.487c0 6.868 5.587 12.454 12.454 12.454 6.866 0 12.453-5.587 12.453-12.454 0-6.866-5.587-12.453-12.453-12.453z\" /><path d=\"M18.891 12.279H13.04V5.882a.893.893 0 1 0-1.785 0v7.29c0 .493.4.892.892.892h6.745a.893.893 0 1 0 0-1.785z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol